import styled from 'styled-components'
import { layout, LayoutProps, margin, MarginProps } from 'styled-system'
import { themeGet } from '@styled-system/theme-get'

type IconButtonProps = MarginProps &
  LayoutProps & {
    active?: boolean
  }

const IconButton = styled.button<IconButtonProps>`
  display: flex;
  align-items: center;
  font-size: 14px;
  font-weight: ${themeGet('fontWeights.1')};
  letter-spacing: -0.2px;
  padding: 0;
  border-radius: 0;
  border: none;
  color: ${themeGet('colors.primary.main')};
  gap: ${themeGet('space.3')}px;

  &:hover {
    background: none;
    color: ${themeGet('colors.primary.slave')};
  }

  &:disabled {
    cursor: default;
  }

  ${margin}
  ${layout}
`

export default IconButton
